export const assets = {
  heroMockup:
    'https://cdn.magicpatterns.com/uploads/4YJLL6yyQxepN22Umj5cYe/biblioteca_arteterapia_magic_1080x1080.webp',
  libraryMockup:
    'https://cdn.magicpatterns.com/uploads/dM9rTf2t4cqVa1c48ruo4i/biblioteca_arteterapia_1080x1080.webp',
  offerMockup:
    'https://cdn.magicpatterns.com/uploads/4g88W2KfWH4TG1kZRPYUEz/biblioteca_arteterapia_mockup_1080.webp',
  finalMockup:
    'https://cdn.magicpatterns.com/uploads/jecg1YxEgvzmpdQzWQsG8s/pausa_propia_mockup_1080_light.webp',
  bonus1Cover:
    'https://cdn.magicpatterns.com/uploads/giFX9zkbxq4ZzhEyFq2CkS/50_cartas_bonus1_magic_1080_optimized.webp',
  bonus2Cover:
    'https://cdn.magicpatterns.com/uploads/inhahPPS7PdkVLSxNKk6be/guia_aplicacion_bonus2_magic_1080_optimized.webp',
}

export const interiorPreviews = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/k65PSETd4h9kncGAphbu1X/rio_de_lo_que_dejo_ir_magic_optimized.webp',
    title: 'El río de lo que dejo ir',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mfsa9KrMqPt5PcfrdcWh9Z/lo_que_puede_moverse_magic_optimized.webp',
    title: 'Lo que puede moverse · página de trabajo',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dHm5FdaZ56Dt7r3yQnZcRi/tormenta_y_quietud_magic_optimized.webp',
    title: 'Tormenta y quietud',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mEhrvnkyoTVfvmbbXM1b29/la_maleta_que_ya_no_quiero_cargar_magic_optimized.webp',
    title: 'La maleta que ya no quiero cargar',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/b8JqyyfvBNN7NQPWM9vNE8/la_maleta_me_llevo_puedo_dejar_magic_optimized.webp',
    title: 'Me llevo · Puedo dejar · página de trabajo',
  },
]
